import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';

import {
  BILLING_TAB_INDEX,
  INDEX_TO_PATH_MAP,
  PATH_TO_INDEX_MAP,
  PLANS_TAB_INDEX,
  USAGE_TAB_INDEX,
} from '../constants';

type Value =
  | typeof BILLING_TAB_INDEX
  | typeof USAGE_TAB_INDEX
  | typeof PLANS_TAB_INDEX;

export const useBillingTabs = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [value, setValue] = useState(PATH_TO_INDEX_MAP[location.pathname]);

  const onChange = (_event: React.SyntheticEvent, newValue: Value) => {
    setValue(newValue);
    navigate(INDEX_TO_PATH_MAP[newValue]);
  };

  useEffect(() => {
    setValue(PATH_TO_INDEX_MAP[location.pathname]);
  }, [location.pathname]);

  return { onChange, value };
};
